import React, { useState } from "react";
import styles from "../styles/menu.module.css";
import { ReactComponent as Logo } from '../ressources/ads_logo.svg';

export default function Menu({ scrolled, navigate, currentPage }) {
    const [mobileOpen, setMobileOpen] = useState(false);

    const close = () => setMobileOpen(false);

    const goTo = (page, hash) => (e) => {
        e.preventDefault();
        close();
        navigate(page);
        if (hash) {
            setTimeout(() => {
                const el = document.getElementById(hash);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 50);
        }
    };

    const goHash = (hash) => (e) => {
        if (currentPage !== 'home') {
            e.preventDefault();
            close();
            navigate('home');
            setTimeout(() => {
                const el = document.getElementById(hash);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 50);
        } else {
            close();
        }
    };

    return (
        <nav className={`${styles.navbar} ${scrolled ? styles.navbarScrolled : ''}`}>
            <div className={styles.navInner}>
                <a href="#accueil" className={styles.navBrand} onClick={goTo('home')}>
                    <Logo className={styles.navLogo} />
                </a>

                <button
                    className={styles.burger}
                    onClick={() => setMobileOpen(!mobileOpen)}
                    aria-label="Menu"
                >
                    <span className={styles.burgerLine}></span>
                    <span className={styles.burgerLine}></span>
                    <span className={styles.burgerLine}></span>
                </button>

                <ul className={`${styles.navList} ${mobileOpen ? styles.navListOpen : ''}`}>
                    <li className={styles.dropdown}>
                        <span className={styles.dropdownToggle}>L’association</span>
                        <ul className={styles.dropdownMenu}>
                            <li><a href="#about" onClick={goHash('about')}>Qui sommes-nous</a></li>
                            <li><a href="#/historique" onClick={goTo('historique')}>Historique</a></li>
                            <li><a href="#/demarche" onClick={goTo('demarche')}>Notre démarche</a></li>
                        </ul>
                    </li>

                    <li className={styles.dropdown}>
                        <span className={styles.dropdownToggle}>Réalisations</span>
                        <ul className={styles.dropdownMenu}>
                            <li><a href="#realisations" onClick={goHash('realisations')}>Campagnes en cours</a></li>
                            <li><a href="#/projets" onClick={goTo('projets')}>Projets antérieurs</a></li>
                        </ul>
                    </li>

                    <li className={styles.navItem}>
                        <a href="#contact" onClick={goHash('contact')}>Contact</a>
                    </li>

                    <li className={styles.navItemDon}>
                        <a href="#don" onClick={goHash('don')}>Faire un don</a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}
